var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/~/isarray/index.js
// module id = 755
// module chunks = 12